import { useEffect, useRef, useState } from 'react';

/**
 * Hook that manages a countdown timer for bid auctions.
 * Starts at 21 seconds, which seems to be the default countdown time for timed auctions, and counts down.
 *
 * @param timeStamp - The timestamp from getCountDown selector.
 *                    Positive = normal countdown, Negative = Fair Warning
 * @returns count and whether we're in the last 5 seconds
 */
export const useBidCountdown = (timeStamp: number) => {
    const [count, setCount] = useState<number>(21);
    const countRef = useRef<number>(count);
    countRef.current = count;

    useEffect(() => {
        const timer = setInterval(() => {
            if (countRef.current > 0) {
                setCount(countRef.current - 1);
                countRef.current = countRef.current - 1;
            }
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        setCount(timeStamp < 0 ? 4 : 21);
    }, [timeStamp]);

    return {
        count,
        isLastFiveSeconds: count < 6,
    };
};
